module.exports = __webpack_public_path__ + "static/pure-e5b7d84f6030537e5684743f8cbb5b56.jpeg";